import React from 'react';
import { Link } from 'react-router-dom';
import { FlaskConical } from 'lucide-react';
import { cx } from '../../lib/cx';

export const BrandMark = ({ size = 'md' }) => (
  <span
    className={cx(
      'inline-flex shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-indigo-500 to-violet-600 text-white shadow-sm',
      size === 'lg' ? 'h-10 w-10' : 'h-7 w-7',
    )}
    aria-hidden="true"
  >
    <FlaskConical size={size === 'lg' ? 20 : 15} />
  </span>
);

/** Logo + name, linking home. The name hides on very narrow screens. */
export const Brand = ({ to = '/', className, suffix }) => (
  <Link to={to} className={cx('flex shrink-0 items-center gap-2 rounded-lg', className)} aria-label="TCM Search home">
    <BrandMark />
    <span className="hidden text-[0.95rem] font-semibold tracking-tight text-fg min-[400px]:inline">
      TCM <span className="font-normal text-muted">Search</span>
    </span>
    {suffix}
  </Link>
);
